import { render, staticRenderFns } from "./question-menu.vue?vue&type=template&id=125788df"
import script from "./question-menu.vue?vue&type=script&lang=js"
export * from "./question-menu.vue?vue&type=script&lang=js"
import style0 from "./question-menu.vue?vue&type=style&index=0&id=125788df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports